/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('data.report', []);